import Link from "./Link"
import { Box } from "@mui/material"

import React, { ReactElement, ReactNode } from "react"

import { observer } from 'mobx-react-lite'
import { useStore } from '../../contexts/store'


type Tab = {
  key: string,
  label: string|ReactNode,
  content: ReactElement,
}

const activeTabStyle = {
  alignContent: "center",
  backgroundColor: "white",
  /*borderTop: "2px solid rgb(108, 108, 211)",
  borderLeft: "2px solid rgb(108, 108, 211)",
  borderRight: "2px solid rgb(108, 108, 211)",
  borderBottom: "2px solid white",*/
  borderBottom: "2px solid rgb(108, 108, 211)",
  color: "rgb(108, 108, 211)",
  display: "grid",
  fontSize: "12px",
  fontWeight: "500",
  gridTemplateColumns: "min-content min-content",
  gridGap: "5px",
  padding: "8px"
}

const tabStyle = {
  alignContent: "center",
  //borderTop: "2px solid white",
  //borderBottom: "2px solid #888",
  color: "rgba(0, 0, 0, 0.6)",
  display: "grid",
  fontSize: "12px",
  fontWeight: "500",
  gridTemplateColumns: "min-content min-content",
  gridGap: "5px",
  padding: "8px",
  //backgroundColor:'#eee',
}

// message from thread
const Subtabs = ({context, activeKey, tabs}: {context:string, activeKey:string|undefined, tabs:Tab[]}) => {

  const { podStore } = useStore()
  //const deviceWidth = uiStore.deviceWidth
  const pod = podStore.pod
  if (!pod) return null
  if (tabs.length === 0) return null

  if (!activeKey) activeKey = tabs[0].key

  function generateUrl(key: string) {
    if (!pod) return ''
    const url = `/pod/${pod.podId}/${context}/${key}`
    return url
  }

  const Menu = () => {
    // show selection menu on small screens
    // if(deviceWidth === "tiny" || deviceWidth === 'smaller') return <SeclectionMenu />
    // else show tab menu

    return (
      <Box sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "2px",
        margin: "0 10px 20px 10px",
        alignItems:'start',
      }}>
        {
        tabs.map((tab, i) => (
          <Box sx={ activeKey === tab.key ? activeTabStyle : tabStyle } style={{textTransform: 'uppercase', whiteSpace:'nowrap'}}>
            <Link noDecoration={true} key={tab.key} to={generateUrl(tab.key)}>
              {tab.label}
            </Link>
          </Box>
        ))
        }
      </Box>
    )
  }

  const content = tabs.filter(tab => tab.key === activeKey)[0].content || tabs[0].content

  return <Box className={"overflowWrapper"} style={{ gridTemplateRows: 'min-content auto' }}>
    <Menu />
    <Box className={"overflowWrapper"}>
    { content }
    </Box>
  </Box>

}

export default observer(Subtabs)